import React, { FC } from 'react';
import styles from './FeaturesList.module.scss';
import Button from '../../../primitives/button/Button';
import { PLATFORM_URL } from '../../../../utils/constants';

const highlights = [
	{
		title: 'AI-Driven Program Creation',
		description:
			'Build a compliance program from scratch or import an existing one — AI maps your initial control set and gets you started in minutes, not weeks.',
	},
	{
		title: 'Multi-Framework Crosswalk',
		description:
			'Evaluate against NIST, ISO, SOC 2, and CMMC side by side. One mapped control set, no duplicated work across standards.',
	},
	{
		title: 'Always-Current Documentation',
		description:
			'Policies and controls stay aligned with regulatory changes automatically — no manual tracking, no stale documentation.',
	},
];

const FeaturesList: FC = () => {
	return (
		<section className={styles['key-features']}>
			<div className={styles.info}>
				<h2>GravityGRC Dynamic Compliance Tool</h2>

				<p>
					An AI-integrated platform that builds and maintains your compliance program
					in real time — mapping controls across frameworks, generating policies, and
					keeping documentation audit-ready without manual upkeep.
				</p>
			</div>

			<div className={styles.grid}>
				{highlights.map((item) => (
					<div className={styles.card} key={item.title}>
						<h3>{item.title}</h3>
						<p>{item.description}</p>
					</div>
				))}
			</div>

			<Button width={220} className={styles.action} href={PLATFORM_URL}>
				Explore Gravity GRC
			</Button>
		</section>
	);
};

export default FeaturesList;